
@switch (type()) {
  @case ('digits') {
    <mat-form-field floatLabel="never" [ngClass]="classField()">
      <span class="placeholder">
        {{control().value != null ? control().value : "..."}}
        @if (suffixWithSpace != null) {
          <span [innerHTML]="suffixWithSpace"></span>
        }
        @if (editIcon()) {
          <mat-icon class="icon-small icon-edit">edit</mat-icon>
        }
      </span>
      <input matInput [max]="max()" digitsOnly [formControl]="control()" (focus)="$event.target.select()" (keyup.enter)="onEnter($event)" autocomplete="off">
    </mat-form-field>
  }
  @case ('decimal') {
    <mat-form-field floatLabel="never" [ngClass]="classField()">
      <span class="placeholder">
        {{control().value != null ? control().value : "..."}}
        @if (suffixWithSpace != null) {
          <span [innerHTML]="suffixWithSpace"></span>
        }
        @if (editIcon()) {
          <mat-icon class="icon-small icon-edit">edit</mat-icon>
        }
      </span>
      <input matInput [max]="max()" digitsOnly decimal="true" [formControl]="control()" (focus)="$event.target.select()" (keyup.enter)="onEnter($event)" autocomplete="off">
    </mat-form-field>
  }
  @case ('financial') {
    <mat-form-field floatLabel="never" [ngClass]="classField()">
      <span class="placeholder">
        {{control().value != null ? (control().value | currency:'EUR':'symbol':'1.0-0') : "..."}}
        @if (suffixWithSpace != null) {
          <span [innerHTML]="suffixWithSpace"></span>
        }
        @if (editIcon()) {
          <mat-icon class="icon-small icon-edit">edit</mat-icon>
        }
      </span>
      <input matInput [formControl]="control()" [negative]="negative()" decimal="false" digitsOnly (focus)="$event.target.select()" (keyup.enter)="onEnter($event)" autocomplete="off">
    </mat-form-field>
  }
  @case ('financial-2') {
    <mat-form-field floatLabel="never" [ngClass]="classField()">
      <span class="placeholder">
        {{control().value != null ? (control().value | currency:'EUR':'symbol':'1.2-2') : "..."}}
        @if (suffixWithSpace != null) {
          <span [innerHTML]="suffixWithSpace"></span>
        }
        @if (editIcon()) {
          <mat-icon class="icon-small icon-edit">edit</mat-icon>
        }
      </span>
      <input matInput [formControl]="control()" digitsOnly decimal="true" [negative]="negative()" (focus)="$event.target.select()" (keyup.enter)="onEnter($event)" autocomplete="off">
    </mat-form-field>
  }
  @case ('text') {
    <mat-form-field floatLabel="never" [ngClass]="classField()">
      <span class="placeholder">
        {{control().value != null ? control().value : "..."}}
        @if (suffixWithSpace != null) {
          <span [innerHTML]="suffixWithSpace"></span>
        }
        @if (editIcon()) {
          <mat-icon class="icon-small icon-edit">edit</mat-icon>
        }
      </span>
      <input matInput type="text" [formControl]="control()" [pattern]="pattern()" (focus)="$event.target.select()" (keyup.enter)="onEnter($event)" autocomplete="off">
    </mat-form-field>
  }
  @case ('percentage') {
    <mat-form-field floatLabel="never" [ngClass]="classField()">
      <span class="placeholder">
        {{control().value != null ? (control().value | number:'1.1-2') : "..."}}%
        @if (suffixWithSpace != null) {
          <span [innerHTML]="suffixWithSpace"></span>
        }
        @if (editIcon()) {
          <mat-icon class="icon-small icon-edit">edit</mat-icon>
        }
      </span>
      <input matInput digitsOnly decimal="true" [formControl]="control()" (focus)="$event.target.select()" (keyup.enter)="onEnter($event)" autocomplete="off">
    </mat-form-field>
  }
  @case ('date') {
    <mat-form-field floatLabel="never" [ngClass]="classField()">
      <span class="placeholder">{{(control().value | date:'longDate' : '' : currentLang) || "..."}}</span>
      <input matInput [matDatepicker]="matDatepicker" [formControl]="control()" (keyup.enter)="onEnter($event)" autocomplete="off">
      <mat-datepicker-toggle matIconSuffix  [for]="matDatepicker"></mat-datepicker-toggle>
      <mat-datepicker #matDatepicker></mat-datepicker>
    </mat-form-field>
  }
}
